import { useState, useEffect } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
    getLeadNotesAction,
    createLeadNoteAction,
} from "../../../../../store/actions/LeadNoteAction";
// import { showErrorAlert } from "../../../../../services/ErrorHandlingService";
import { FaMicrophone } from "react-icons/fa";
import { useRef } from "react";
import { formatDate } from "../../../../../utils/dateUtils"

const LeadNotes = () => {
    const dispatch = useDispatch();
    const { id } = useParams();

    const recognitionRef = useRef(null);

    const [noteDescription, setNoteDescription] = useState("");
    const [isRecording, setIsRecording] = useState(false);
    const [speechLang, setSpeechLang] = useState("en-IN");

    const leadDetails = useSelector((state) => state.leadState?.leadDetails);
    const lead_id = leadDetails?.lead_id || id;

    const notesState = useSelector((state) => state.leadNotes || {});
    const { notes = [], isLoading = false, error = null } = notesState;

    const [showModal, setShowModal] = useState(false);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const toggleLanguage = () => {
        setSpeechLang((prev) => (prev === "en-IN" ? "mr-IN" : "en-IN"));
    };
    const startListening = () => {
        const SpeechRecognition =
            window.SpeechRecognition || window.webkitSpeechRecognition;
    
        if (!SpeechRecognition) {
            alert("Your browser does not support Speech Recognition");
            return;
        }
    
        // 🚫 Already recording
        if (isRecording) return;
    
        const recognition = new SpeechRecognition();
        recognitionRef.current = recognition;
    
        recognition.lang = speechLang;
        recognition.continuous = false;
        recognition.interimResults = false;
    
        setIsRecording(true);
    
        recognition.onresult = (event) => {
            const spokenText = event.results[0][0].transcript;
    
            setFormData((prev) => ({
                ...prev,
                note: prev.note
                    ? prev.note + " " + spokenText
                    : spokenText,
            }));
        };
    
        recognition.onerror = (event) => {
            console.warn("Speech recognition error:", event.error);
    
            // ❌ aborted is normal → ignore it
            if (event.error !== "aborted") {
                alert("Speech recognition failed. Please try again.");
            }
    
            setIsRecording(false);
        };
    
        recognition.onend = () => {
            setIsRecording(false);
            recognitionRef.current = null;
        };
    
        recognition.start();
    };
    

    const [formData, setFormData] = useState({
        note: "",
    });
    const [submitting, setSubmitting] = useState(false);
    useEffect(() => {
        if (lead_id) {
            dispatch(getLeadNotesAction(lead_id));
        }
    }, [dispatch, lead_id, refreshTrigger]);

    const handleModalClose = () => {
        if (recognitionRef.current) {
            recognitionRef.current.stop();
            recognitionRef.current = null;
        }
    
        setIsRecording(false);
        setShowModal(false);
        setFormData({ note: "" });
    };
    

    const handleAddClick = () => {
        setShowModal(true);
        setFormData({ note: "" });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (submitting) return;
        setSubmitting(true);
        if (!lead_id) {
            showErrorAlert("Lead ID not found. Please refresh and try again.", "error");
            return;
        }

        try {
            const payload = { note: formData.note };
            const result = await dispatch(createLeadNoteAction(payload, lead_id));


            if (result && result.success) {
                handleModalClose();
                setRefreshTrigger((prev) => prev + 1);
            } else {
                // showErrorAlert("Failed to add note.", "error");
            }
        } catch (err) {
            console.error("Add note error:", err);
            // showErrorAlert("Something went wrong.", "error");
        }
        finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="card shadow-none">
            <div className="card-body">
                {/* Add Note Button */}
                <div className="d-flex justify-content-end align-items-center mb-3">
                    <Button variant="outline-primary" size="sm" onClick={handleAddClick} disabled={!lead_id}>
                        Add Notes
                    </Button>
                </div>

                {/* Notes List */}
                {isLoading ? (
                    <div className="text-center">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p>Loading notes...</p>
                    </div>
                ) : notes && notes.length > 0 ? (
                    notes.map((note, index) => (
                        <div
                            key={note.note_id || index}
                            className="mb-2 custom-timeline-panel timeline-panel bgl-dark flex-wrap border-0 p-3 rounded"
                        >
                            <h6 className="fw-bold">{note.note || "No content"}</h6>
                            <p className="fs-15 mb-0">
  Date:{" "}
  {note.created_at
    ? `${formatDate(note.created_at)}`
    : "Not available"}
</p>

                        </div>
                    ))
                ) : (
                    <li className="text-center text-muted">No Notes found.</li>


                )}

                {/* Add Note Modal */}
                <Modal show={showModal} onHide={handleModalClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Add Note</Modal.Title>
                    </Modal.Header>
                    <form onSubmit={handleSubmit}>
                        <Modal.Body>
                            <div className="position-relative">
                                <label className="form-label">
                                    Notes <span className="text-danger">*</span>
                                </label>
                                <textarea
                                    className="form-control pe-5"
                                    rows="4"
                                    required
                                    placeholder="Enter your notes here..."
                                    name="note"
                                    value={formData.note}
                                    onChange={handleChange}
                                />
                                <button
                                    type="button"
                                    onClick={startListening}
                                    disabled={isRecording}
                                    style={{
                                        position: "absolute",
                                        right: "10px",
                                        bottom: "10px",
                                        width: "34px",
                                        height: "34px",
                                        borderRadius: "50%",
                                        border: "none",
                                        background: isRecording ? "#ff4d4d" : "#f1f3f5",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                        transition: "0.3s",
                                        boxShadow: isRecording
                                            ? "0 0 10px 3px rgba(255, 0, 0, 0.6)"
                                            : "0 2px 4px rgba(0,0,0,0.12)",
                                        transform: isRecording ? "scale(1.1)" : "scale(1)",
                                    }}
                                >
                                    <FaMicrophone size={15} color={isRecording ? "white" : "#333"} />
                                </button>

                                {/* LANGUAGE TOGGLE BUTTON */}
                                <button
                                    type="button"
                                    onClick={toggleLanguage}
                                    style={{
                                        position: "absolute",
                                        right: "55px",
                                        bottom: "10px",
                                        padding: "2px 10px",
                                        borderRadius: "12px",
                                        border: "1px solid #ccc",
                                        background: "#fff",
                                        fontSize: "12px",
                                        cursor: "pointer",
                                    }}
                                >
                                    {speechLang === "en-IN" ? "EN" : "MR"}
                                </button>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleModalClose}>
                                Cancel
                            </Button>
                            {/* <Button type="submit" variant="primary">
                                Save
                            </Button> */}
                            <Button type="submit" variant="primary" disabled={submitting}>
                                {submitting ? (
                                    <>
                                        <Spinner animation="border" size="sm" className="me-2" />
                                        Saving...
                                    </>
                                ) : (
                                    "Save"
                                )}
                            </Button>
                        </Modal.Footer>
                    </form>
                </Modal>
            </div>
        </div>
    );
};

export default LeadNotes;
